import axios from 'axios';


// Fetch all training programs
export const getAllPrograms = async () => {
  try {
    const response = await axios.get(`/training/programs`);
    return response.data.data.programs;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error fetching training programs');
  }
};

// Fetch training program by ID
export const getProgramById = async (id) => {
  try {
    const response = await axios.get(`/training/programs/${id}`);
    return response.data.data.program;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error fetching training program');
  }
};

// Create a new training program
export const createProgram = async (programData) => {
  try {
    const response = await axios.post(`/training/programs`, programData);
    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error creating training program');
  }
};

// Update a training program
export const updateProgramById = async (id, programData) => {
  try {
    const response = await axios.put(`/training/programs/${id}`, programData);
    return response.data.data.program;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error updating training program');
  }
};

// Delete (deactivate) a training program
export const deleteProgramById = async (id) => {
  try {
    await axios.delete(`/training/programs/${id}`);
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error deleting training program');
  }
};

// Fetch all training assignments
export const getAllAssignments = async () => {
  try {
    const response = await axios.get(`/training/assignments`);
    return response.data.data.assignments;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error fetching training assignments');
  }
};

// Fetch assignments by user ID
export const getAssignmentsByUserId = async (userId) => {
  try {
    const response = await axios.get(`/training/assignments/user/${userId}`);
    return response.data.data.assignments;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error fetching assignments for user');
  }
};


export const updateAssignmentById = async (id, assignmentData, token) => {
  try {
    const response = await axios.put(`/training/assignments/${id}`, assignmentData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to update assignment' };
  }
};
// Create a new training assignment
export const assignTraining = async (assignmentData) => {
  try {
    const response = await axios.post(`/training/assignments`, assignmentData);
    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error assigning training');
  }
};

// Update assignments by user ID
export const updateAssignmentsByUserId = async (userId, assignmentData) => {
  try {
    const response = await axios.put(`/training/assignments/user/${userId}`, assignmentData);
    return response.data.data.assignments;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error updating assignments');
  }
};

// Delete a training assignment
export const deleteAssignmentById = async (id) => {
  try {
    await axios.delete(`/training/assignments/${id}`);
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error deleting training assignment');
  }
};

// Fetch all training progress
export const getAllProgress = async ({ employeeName = '', programName = '', completionDate = '' } = {}) => {
  try {
    const response = await axios.get(`/training/progress`, {
      params: { employeeName, programName, completionDate },
    });
    return response.data.data.progress;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error fetching training progress');
  }
};

export const getProgressByAssignment = async (assignmentId) => {
  try {
    const response = await axios.get(`/training/progress/${assignmentId}`);
    return response.data.data.progress;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error fetching progress for assignment');
  }
};

export const updateProgress = async (assignmentId, progressData) => {
  try {
    const response = await axios.put(`/training/progress/${assignmentId}`, progressData);
    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error updating training progress');
  }
};

